/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  projectValueFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectValueFilterController', ['$scope',
      function ($scope) {
        $scope.componentName = "projectValueFilter";

        $scope.resetFilter = function () {
          delete $scope.criteria["dollarValueFrom"];
          delete $scope.criteria["dollarValueTo"];
        };

        $scope.removeProjectValueFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectValueFilter");
        };


        $scope.showInvalidMessage = function(){
          if (!$scope.projectValueFilterForm) return;
          // this is not very nice looking logic - it is caused by the either/or/both
          // nature of the value range filter as well as the fact that  zero
          // is valid but falsey

          // If I  can get  this subjected to some proper tests, I  might be able to
          // do something about the ugly chain of conditionals

          var showMessage = false
          if (!angular.isNumber($scope.criteria.dollarValueFrom) && $scope.criteria.dollarValueFrom != "")
            showMessage = true;

          if(!angular.isNumber($scope.criteria.dollarValueTo) && $scope.criteria.dollarValueTo != "" )
            showMessage = true;

          if (!$scope.criteria.dollarValueTo && !$scope.criteria.dollarValueFrom)
            showMessage = true;

          if (angular.isNumber($scope.criteria.dollarValueFrom) && !$scope.criteria.dollarValueTo)
            showMessage = false;

          if (angular.isNumber($scope.criteria.dollarValueTo) && !$scope.criteria.dollarValueFrom)
            showMessage = false;

          if(angular.isNumber($scope.criteria.dollarValueFrom)
              && angular.isNumber($scope.criteria.dollarValueTo)
              && $scope.criteria.dollarValueTo <= $scope.criteria.dollarValueFrom)
            showMessage = true;

          if ($scope.projectValueFilterForm.$pristine)
            showMessage = false;


          $scope.projectValueFilterForm.$setValidity("$valid", !(showMessage || $scope.projectValueFilterForm.$pristine))
          return showMessage;
        };

      }])
    .directive('projectValueFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectValueFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            var txtDollarValueFrom = iElement.find('#txtDollarValueFrom')
            txtDollarValueFrom.attr('placeholder', txtDollarValueFrom.attr('placeholder-text'));

            var txtDollarValueTo = iElement.find('#txtDollarValueTo')
            txtDollarValueTo.attr('placeholder', txtDollarValueTo.attr('placeholder-text'));
          },

          controller: 'projectValueFilterController'
        };
      }]);
//------------------------------------------------------------------------

